import { isEmpty } from 'lodash'
import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import Dropdown from '@ublique/components/Dropdown'
import MultiSelect from '@ublique/components/MultiSelect'

const CreationForm = ({
  t,
  rolesList,
  role,
  pages,
  pagesList,
  onChange,
  isRoleInvalid,
  isPagesInvalid
}) => {
  const itemToString = (item) => (item ? t(item.label) : '')
  const { t: outputT } = useTranslation('OutputView')

  const formatPageSelected = (selectedItems) => {
    const available = selectedItems.map(({ value }) => value)

    return pagesList.map(({ component, title }) => ({
      page: component,
      selected: available.includes(component),
      label: outputT(title)
    }))
  }

  return (
    <Fragment>
      <Dropdown
        id='roles'
        titleText={t('RolesManagement.InstancesModal.Roles')}
        label={t('RolesManagement.InstancesModal.Roles')}
        placeholder={t('RolesManagement.InstancesModal.Roles')}
        selectedItem={role ? { label: role, value: role } : null}
        invalidText={t('OutputManagement.EmptyRole')}
        invalid={isRoleInvalid}
        onChange={({ selectedItem }) => onChange('role', selectedItem.value)}
        name='roles'
        items={rolesList?.map((role) => ({
          label: role?.roleName,
          value: role?.roleName
        }))}
        itemToString={itemToString}
      />
      <MultiSelect
        id='pages'
        useTitleInItem={false}
        initialSelectedItems={
          pages
            ? pages.map(({ label, value }) => ({
                label,
                value
              }))
            : []
        }
        titleText={t('OutputManagement.PageList')}
        label={t('OutputManagement.PageList')}
        light
        name='pages'
        value={pages.map(({ label, value }) => ({
          label,
          value
        }))}
        onChange={({ selectedItems }) => {
          onChange('pages', formatPageSelected(selectedItems))
        }}
        items={pagesList.map(({ component, title, path }) => ({
          label: outputT(title) + ' - ' + path,
          value: component
        }))}
        itemToString={itemToString}
        invalid={isPagesInvalid}
        invalidText={t('OutputManagement.EmptyOutputPages')}
      />
    </Fragment>
  )
}

export default CreationForm
